module.exports = "<p>\n  new-home works!\n</p>\n"